import React, { Component } from 'react'
import Dropzone from 'react-dropzone'

import { fileOptionsConstants } from '../constants/fileOptions'

import { ReactComponent as FolderClose } from '../images/folder-line.svg'
import { ReactComponent as FolderCloseWhite } from '../images/folder-line-white.svg'

class GridView extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      newFolderName: '',
    }
    this.gridRefs = []
  }

  createRef = ref => {
    if (ref) this.gridRefs.push(ref)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false)
  }

  componentDidUpdate(prevProps) {
    const { pageNo, baseFolder, isFilesFetchInProgress } = this.props
    if (
      baseFolder !== prevProps.baseFolder ||
      pageNo !== prevProps.pageNo ||
      (isFilesFetchInProgress !== prevProps.isFilesFetchInProgress &&
        !prevProps.isFilesFetchInProgress)
    ) {
      this.gridRefs = []
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
  }

  handleClick = event => {
    let index = this.props.selectedItem
    if (this.gridRefs.length > 0) {
      if (
        this.gridRefs[index] &&
        !this.gridRefs[index].contains(event.target)
      ) {
        const classList = event.target.classList.value

        const items = ['uploadButton', 'createfolderButton', 'buttonoptions']
        if (items.every(item => !classList.includes(item))) {
          this.props.clickItems('', false)
        }
      }
    }
    return
  }

  capture = evt => {
    const { newFolderName } = this.state
    if (
      evt.key === 'Enter' ||
      (typeof evt.key === 'undefined' && newFolderName.trim() !== '')
    ) {
      this.props.capture(newFolderName, false)
      this.setState({
        newFolderName: '',
      })
    } else if (typeof evt.key === 'undefined') {
      this.setState({
        newFolderName: '',
      })
      this.props.capture('', false)
    }
  }

  setNewFolderValue = evt => {
    this.setState({ newFolderName: evt.target.value })
  }

  captureDoubleClick = item => {
    this.gridRefs = []
    this.props.captureDoubleClick(item)
  }

  renderCreateFolder = () => {
    const { newFolderName } = this.state
    const { isCreateFolderInProgress } = this.props
    return (
      <div className="grid__box-container">
        <div className="grid__box-container--inner">
          <div className="grid__box-container--front">
            <div className="grid__box-options-container" />
            {isCreateFolderInProgress ? (
              <div className="grid__box-content">
                <FolderClose />
                <div style={{ marginTop: '10px' }}>
                  <div className="loader--small" />
                </div>
              </div>
            ) : (
              <div className="grid__box-content">
                <FolderClose />
                <div
                  className="ppvx_text-input"
                  style={{
                    minWidth: '90%',
                    maxWidth: '90%',
                    marginTop: '22px',
                  }}
                >
                  <input
                    className="ppvx_text-input__control"
                    type="text"
                    name="new_folder"
                    id="new_folder"
                    placeholder=" "
                    autoFocus={true}
                    value={newFolderName}
                    onKeyPress={ent => this.capture(ent)}
                    onChange={evt => this.setNewFolderValue(evt)}
                    onBlur={evt => this.capture(evt)}
                  />
                  <label
                    htmlFor="new_folder"
                    className="ppvx_text-input__label"
                  >
                    Enter some text
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderDummyGrid = () => {
    const placeHolderGrids = []
    for (let index = 0; index <= 3; index++) {
      placeHolderGrids.push(
        <div className="grid__box-container" key={index}>
          <div className="dummy-grid--photo">
            <div />
          </div>
          <div className="dummy-grid--content">
            <div />
          </div>
        </div>,
      )
    }

    return <div className="container-dummy_grid">{placeHolderGrids}</div>
  }

  renderOptions = item => {
    const { user } = this.props
    return fileOptionsConstants.FileOptions[user.accType]
      .filter(fileItem => fileItem.type === item.fileType)
      .map(fileItem =>
        fileItem.options.map((options, index) => {
          return (
            <div
              key={`${options}_${index}`}
              className="grid__box-options--overflow"
            >
              <a
                className="ppvx_overflow-menu__list-item ppvx__text--md"
                onClick={() => this.props.onOptionsClick(item, options)}
              >
                {options}
              </a>
            </div>
          )
        }),
      )
      .flat()
  }

  renderFolderOptions = item => {
    return (
      <div className="ppvx_overflow-menu__list ppvx_overflow-menu__list--open">
        {this.renderOptions(item)}
      </div>
    )
  }

  renderGridFrontContent = (index, item, selectedItem) => {
    return (
      <div className="grid__box-container--front">
        <div className="grid__box-options-container">
          <span
            className={`ppvx_icon ppvx_icon--size_xs ppvx_icon-elipsis-vertical grid__box-ellipse-icon ${
              index === selectedItem ? 'grid__active-item' : ''
            }`}
            onClick={() => this.props.fileOptionStatus(index, true)}
          />
        </div>
        {this.renderIconAndName(item, index, selectedItem)}
      </div>
    )
  }

  renderIconAndName = (item, index, selectedItem) => {
    return (
      <div
        className="grid__box-content"
        onClick={() => this.props.clickItems(index, true)}
      >
        {item.fileType === 'folder' ? (
          <span>
            {selectedItem === index ? <FolderCloseWhite /> : <FolderClose />}
            <span className="vx_a11yText">folder</span>
          </span>
        ) : (
          <span
            className={`ppvx_icon ppvx_icon--size_lg grid__box-file-type-icon
           ${fileOptionsConstants.Icons[item.fileType]}
          ${index === selectedItem ? 'grid__active-item' : ''}`}
          />
        )}
        <div
          className={`ppvx_text--md grid__box-folder-name ${
            index === selectedItem ? 'grid__active-item' : ''
          }`}
        >
          {item.fileName}
        </div>
        {/* {this.checkFileNameWithUploadList(item).length > 0 && (
          <div
            className="ppvx_progress-meter"
            style={{
              width: '100%',
              padding: '0px',
            }}
          >
            <progress max="100" value="55" />
          </div>
        )} */}
      </div>
    )
  }

  checkFileNameWithUploadList = item => {
    const { filesToUpload } = this.props

    let uniqueResultTwo = filesToUpload.filter(function(file1) {
      return file1.name === item.fileName
    })
    return uniqueResultTwo
  }

  renderActualGrid = () => {
    const {
      selectedItem,
      files,
      showOptions,
      showButton,
      showCreateFolder,
      filesToUpload,
    } = this.props
    return files.results && files.results.length > 0
      ? files.results.map((item, index) => {
          return (
            <div
              ref={this.createRef}
              key={index}
              id={`gridView_${index}`}
              className={`grid__box-container ${
                index === selectedItem ? 'grid__active-item' : ''
              }`}
              onDoubleClick={() => this.captureDoubleClick(item)}
            >
              {showOptions &&
                !showButton &&
                index === selectedItem &&
                this.renderFolderOptions(item)}
              <div className="grid__box-container--inner">
                {this.renderGridFrontContent(index, item, selectedItem)}
              </div>
            </div>
          )
        })
      : !showCreateFolder && filesToUpload.length === 0 && (
          <div className="no-data__msg">
            <div className="ppvx__text--md">No Files/Folders found. </div>
            <div className="no-data__msg--sub">
              Drag and drop files to upload / Create Folder
            </div>
          </div>
        )
  }

  renderGrids = () => {
    const {
      showCreateFolder,
      isFilesFetchInProgress,
      files,
      filesToUpload,
    } = this.props
    return (
      <div
        className={`grid__view-content-holder ${
          !isFilesFetchInProgress &&
          !showCreateFolder &&
          filesToUpload.length === 0 &&
          (files.results && files.results.length === 0)
            ? 'grid__view-content-holder--empty'
            : ''
        }`}
      >
        <div
          className={`grid__view-content ${
            !isFilesFetchInProgress &&
            !showCreateFolder &&
            filesToUpload.length === 0 &&
            (files.results && files.results.length === 0)
              ? 'grid__view-content--empty'
              : ''
          }`}
        >
          {showCreateFolder && this.renderCreateFolder()}
          {filesToUpload.length > 0 && this.renderUploadFiles()}
          {isFilesFetchInProgress
            ? this.renderDummyGrid()
            : this.renderActualGrid()}
        </div>
      </div>
    )
  }

  renderUploadFiles = () => {
    const { filesToUpload, baseFolder } = this.props

    return (
      filesToUpload.length > 0 &&
      filesToUpload.map((item, index) => {
        return (
          baseFolder === item.basePath && (
            <div
              id={`gridView_upload_file_${index}`}
              className="grid__box-container "
              ref={this.createRef}
              key={index}
            >
              <div className="grid__box-container--inner">
                <div className="grid__box-container--front">
                  <div className="grid__box-options-container">
                    <span className="ppvx_icon ppvx_icon--size_xs ppvx_icon-elipsis-vertical grid__box-ellipse-icon " />
                  </div>
                  <div className="grid__box-content">
                    <span>
                      <span className="ppvx_icon ppvx_icon--size_lg grid__box-file-type-icon ppvx_icon-invoice " />
                      <span className="vx_a11yText">folder</span>
                    </span>
                    <div className="ppvx_text--md grid__box-folder-name ">
                      {item.name}
                    </div>
                    <div
                      className="ppvx_progress-meter"
                      style={{
                        width: '100%',
                        padding: '0px',
                      }}
                    >
                      <progress max="100" value="55" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )
      })
    )
  }

  renderGridView = () => {
    return (
      <Dropzone onDrop={acceptedFiles => console.log(acceptedFiles)}>
        {({ getRootProps }) => (
          <div
            {...getRootProps()}
            className="grid__view-conatiner"
            id="gridView"
            data-testid="grid-view"
          >
            {this.renderGrids()}
          </div>
        )}
      </Dropzone>
    )
  }

  render() {
    return this.renderGridView()
  }
}
export default GridView
